/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}
 /* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
.connection-none {
  padding: 1.5rem 8rem;
}
.connection-none p {
  margin: 0;
}
.connection-results {
  position: relative;
  z-index: 0;
}
.connection-results section {
  margin-bottom: 20px;
}
.connection-label {
  margin: 0 0 4px;
  font-size: inherit;
  font-weight: inherit;
}
.connection-header {
  display: grid;
  grid-template-columns: 4.75rem 1fr 20rem;
  gap: 2rem;
  flex-grow: 1;
}
.connection-header > * {
  align-self: center;
}
.connection-number {
  color: #e2002a;
}
.connection-title {
  color: #111B42;
}
.connection-vehicle-possible, .connection-vehicle-not-possible {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: normal;
}
.connection-vehicle-possible oebbx-icon svg, .connection-vehicle-not-possible oebbx-icon svg {
  display: block;
  fill: currentColor;
  width: 26px;
  height: 22px;
}
.connection-vehicle-possible {
  color: #008039;
}
.connection-vehicle-not-possible {
  color: #6e6e6e;
}
@media screen and (max-width: 768px) {
  .connection-header {
    grid-template-columns: 4.75rem 1fr;
    gap: 0.25rem;
    margin-right: -1.5rem;
  }
  .connection-vehicle-possible, .connection-vehicle-not-possible {
    display: none;
  }
}

.connections-form {
  background: #ffffff;
  margin-bottom: 0.25rem;
  padding: 1.25rem;
}
.connections-form fieldset {
  padding: 0;
  border: none;
}
.connections-form-grid {
  display: grid;
  grid-template-columns: 11.5rem 1fr auto;
  gap: 1.25rem 0.75rem;
}
.connections-form-label {
  display: inline-block;
  font-weight: bold;
  padding-right: 1rem;
}
.connections-form-label span {
  position: relative;
  display: block;
  background: #e2002a;
  color: #ffffff;
  padding: 7px;
}
.connections-form-label span:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 22px;
  height: 22px;
  transform: translate(50%, -50%) rotate(45deg);
  transform-origin: 50% 50%;
  background: #e2002a;
}
.connections-form-country input {
  padding: 1.125rem 0.875rem;
  width: calc(100% - 35px);
  max-width: 285px;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
}
.connections-form-date {
  width: 100%;
  max-width: 285px;
  min-width: unset;
}
.connections-form-radio {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  display: inline-block;
  margin: 0;
  width: 1.25rem;
  height: 1.25rem;
  border: 5px solid #BABDC0;
  background-color: #BABDC0;
  border-radius: 50%;
}
.connections-form-radio:checked {
  border-color: #e2002a;
  background-color: #ffffff;
}
.connections-form-radio-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem;
}
.connections-form-radio-label:hover, .connections-form-radio-label:focus-within {
  background-color: #f5f5f5;
}
@media screen and (max-width: 540px) {
  .connections-form-grid {
    grid-template-columns: 1fr;
  }
  .connections-form-grid label {
    max-width: 11.5rem;
  }
}
@media screen and (min-width: 541px) and (max-width: 768px) {
  .connections-form-grid {
    grid-template-columns: 11.5rem 1fr;
  }
  .connections-form-direction {
    grid-column: 1/-1;
  }
}
@media screen and (max-width: 768px) {
  .connections-form-grid {
    gap: 0.5rem;
  }
  .connections-form-direction {
    margin-bottom: 1rem;
  }
}

.oebb-autocomplete-wrapper {
  position: relative;
}
.oebb-autocomplete-list {
  display: none;
  position: absolute;
  box-sizing: border-box;
  z-index: 15;
  min-width: 350px;
  max-height: 300px;
  margin: 0;
  padding: 0;
  background: #ffffff;
  border: 1px solid #babdc0;
  transform: translateY(2px);
  overflow-y: auto;
  box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
  scrollbar-width: thin;
  scrollbar-color: #babdc0 #ffffff;
}
.oebb-autocomplete-list {
  scrollbar-face-color: #babdc0;
  scrollbar-track-color: #ffffff;
}
.oebb-autocomplete-list::-webkit-scrollbar {
  width: 14px;
}
.oebb-autocomplete-list::-webkit-scrollbar-track {
  background: #ffffff;
}
.oebb-autocomplete-list::-webkit-scrollbar-thumb {
  background-color: #babdc0;
  border-radius: 6px;
  border: 3px solid #ffffff;
}
.oebb-autocomplete-list .oebb-autocomplete-item {
  position: relative;
  padding: 0.75rem 1.25rem;
  cursor: pointer;
}
.oebb-autocomplete-list .oebb-autocomplete-item:not(:last-child) {
  border-bottom: 1px solid var(--form-input-border-color);
}
.oebb-autocomplete-list .oebb-autocomplete-item:hover, .oebb-autocomplete-list .oebb-autocomplete-item--active {
  background-color: #ebebeb;
}